/* eslint-disable max-len */
// import { Opt, Optional, ensure } from "../../mary-lib/utils/Optional";

import { ReduxState, CollectiveInvoiceForm } from "./ReduxState";
import { ClaimFilters } from "./Claims/Types";
import { CollectiveInvoiceFilters } from "./CollectiveInvoice/Types";
import { ClaimMatchFilters } from "./ClaimMatch/Types";
import { IncassoFilters } from "./Incassos/Types";
import { StatementFilters } from "./Statements/Types";
import { GeneralLedgerFilters } from "./GeneralLedgers/Types";
import { PolicyFilters } from "./Policies/Types";
import { FileFilters } from "./Files/Types";
import { InvoiceFilters } from "./Invoice/Types";
import { PartnerFilters } from "./Partners/Types";
import { ExcassoFilters } from "./Excassos/Types";
import { MBFilters } from "./ManualBooking/Types";
import { BookingPeriodFilters } from "./BookingPeriod/Types";
import { PaymentFilters } from "./PartnerPayments/Types";
import { MandateFilters } from "./Mandates/Types";
import { ModelFilters } from "./Models/Types";
import { ProductFilters } from "./Product/Types";
import { TariffFilters } from "./Tariffs/Types";
import { State } from "../utils/redux/State";

export type FilterTypes = ClaimFilters | ClaimMatchFilters | IncassoFilters
| StatementFilters | PolicyFilters | CollectiveInvoiceFilters | GeneralLedgerFilters | FileFilters | InvoiceFilters
| PartnerFilters | ExcassoFilters | MBFilters | BookingPeriodFilters | PaymentFilters | MandateFilters
| ModelFilters | ProductFilters | TariffFilters;
/**
 *
 */
export enum FilterScope {
    CLAIMS = "CLAIMS",
    INCASSOS = "INCASSOS",
    EXCASSOS = "EXCASSOS",
    CLAIM_MATCH = "CLAIM_MATCH",
    STATEMENTS = "STATEMENTS",
    COLLECTIVE_INVOICES = "COLLECTIVE_INVOICES",
    INVOICES = "INVOICES",
    POLICIES = "POLICIES",
    PARTNERS = "PARTNERS",
    GENERAL_LEDGER = "GENERAL_LEDGER",
    FILES = "FILES",
    MANUAL_BOOKING = "MANUAL_BOOKING",
    BOOKING_PERIOD = "BOOKING_PERIOD",
    PAYMENTS = "PAYMENTS",
    MANDATES = "MANDATES",
    MODELS = "MODELS",
    PRODUCTS = "PRODUCTS",
    TARIFFS = "TARIFFS",
}

interface FilterScopeToType {
    [FilterScope.CLAIMS]: ClaimFilters;
    [FilterScope.INCASSOS]: IncassoFilters;
    [FilterScope.EXCASSOS]: ExcassoFilters;
    [FilterScope.CLAIM_MATCH]: ClaimMatchFilters;
    [FilterScope.STATEMENTS]: StatementFilters;
    [FilterScope.COLLECTIVE_INVOICES]: CollectiveInvoiceFilters;
    [FilterScope.INVOICES]: InvoiceFilters;
    [FilterScope.POLICIES]: PolicyFilters;
    [FilterScope.PARTNERS]: PartnerFilters;
    [FilterScope.GENERAL_LEDGER]: GeneralLedgerFilters;
    [FilterScope.FILES]: FileFilters;
    [FilterScope.MANUAL_BOOKING]: MBFilters;
    [FilterScope.BOOKING_PERIOD]: BookingPeriodFilters;
    [FilterScope.PAYMENTS]: PaymentFilters;
    [FilterScope.MANDATES]: MandateFilters;
    [FilterScope.MODELS]: ModelFilters;
    [FilterScope.PRODUCTS]: ProductFilters;
    [FilterScope.TARIFFS]: TariffFilters;
};

export const filterHasValue = (value?: string | number) => !!value || value === 0;

/**
 *
 * @param s
 */
export const getFilters = <S extends FilterScope>(
    s: ReduxState,
    scope: S,
): FilterScopeToType[S] =>
    s.prop("filters")?.prop(scope)?.map((f: FilterTypes) => ({ ...f })) as FilterScopeToType[S] ?? {};

export const getDuration = (duration: State<CollectiveInvoiceForm>) =>
    duration.map(f => ({
        ...f,
    }));

export const searchableFilters = (filters: FilterTypes, defaultFilters?: FilterTypes): boolean => Object.keys(filters).filter(filter => !defaultFilters
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    ? true : Object.keys(defaultFilters).every(dF => (dF !== filter || dF === filter) && (defaultFilters[dF] !== filters[filter]))).some(k => filterHasValue(filters[k]));

export const hasSearchableFilters = <S extends FilterScope>(
    s: ReduxState,
    scope: S,
    defaultFilters?: FilterScopeToType[S],
): boolean =>
    s.prop("filters")?.prop(scope)?.map((f: FilterScopeToType[S]) =>
        searchableFilters(f, defaultFilters),
    ) ?? false;
